module.exports = __webpack_public_path__ + "static/img/HK.4d7eb849.svg";